<template>
  <div>		
		<div class="pg-header">
			<div>
				<label class="title">疾病标签</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>系统管理</span>|
					<span class="active">疾病标签</span>
				</div>
				<!-- <a class="back noline" @click="goBack">返回</a> -->
			</div>
		</div>
		
		<div class="table-wrap">
			<div class="search-bar">
				<label>标签名称
					<el-input size="small" placeholder="标签名称" clearable v-model.trim="filter.name" @keyup.enter.native="handleFilter(0)"></el-input>
				</label>
				<el-button size="mini" icon="el-icon-search" round @click="handleFilter(0)">搜索</el-button>
			</div>
			<div class="action-bar">
				<el-button type="primary" size="mini" round @click="showDlg">新增标签</el-button>
				
			</div>
			<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
				<!-- <el-table-column fixed="left" type="selection" width="55"></el-table-column> -->
				<el-table-column prop="name" label="标签名称" show-overflow-tooltip ></el-table-column>

				<el-table-column prop="reviser" label="更新人" width="200"></el-table-column>
				<el-table-column prop="date" label="更新记录时间" width="200"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200">
					<template slot-scope="scope">
						<div class="tab-action">
							<el-tooltip content="修改" placement="top" :enterable="false"><i class="el-icon-edit-outline" @click="showDlg(scope.row)"></i></el-tooltip>
						</div>
					</template>
				</el-table-column>
			</el-table>	
			<div class="pagination">
				<el-row>
					<el-col :span="12">
						<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
						<div class="record">总计<span v-text="list.total"></span>条记录</div>
					</el-col>
					<el-col :span="12" style="text-align: right;">
						<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
					</el-col>
				</el-row>
			</div>
		</div>

		<el-dialog :title="form.id > 0 ? '修改标签' : '新增标签'" width="800px" center :visible.sync="dlg.active">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
				<el-form-item label="标签名称" prop="name">
					<el-input autocomplete="off" maxlength="20" :show-word-limit="true" v-model="form.name"></el-input>
				</el-form-item>

				<el-form-item label="ICD编码">
					<el-select v-model="icd.value" size="small" filterable remote reserve-keyword placeholder="请输入关键词" :loading="icd.loading" :remote-method="onLoadIcd">
						<el-option v-for="item in icd.source" :key="item.icdId" :label="item.icdName" :value="item.icdId"></el-option>
					</el-select>

					<el-button type="primary" size="mini" style="margin-left: 10px;" :loading="isLoading" @click="onAddIcd">添加</el-button>
					<!-- <el-transfer filterable :titles="['全部ICD编码', '已选ICD编码']" :data="listIdc.data" v-model="form.icds"></el-transfer> -->
				</el-form-item>


				<el-form-item label="">

					<el-table ref="multipleTable" max-height="600" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="icd.list" v-loading="isLoading">
						<el-table-column prop="icdCode" label="ICD编码"></el-table-column>
						<el-table-column prop="icdName" label="ICD名称"></el-table-column>
						<el-table-column label="操作" width="60" align="center">
							<template slot-scope="scope">
								<div class="tab-action">
									<el-tooltip content="删除" placement="top" :enterable="false"><i class="el-icon-delete" @click="onRemoveIcd(scope.row)"></i></el-tooltip>
								</div>
							</template>
						</el-table-column>
					</el-table>

				</el-form-item>
			

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="saveForm">保 存</el-button>
			</div>
		</el-dialog>
		
		
  </div>
	
			
</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';
import dayjs from 'dayjs';

export default {
	mixins: [mixin],
	data(){
		return {
			dlg: {
				active: false,
				rules: {
					name: {required: true, message: '请输入模板名', trigger: 'blur'},
					// departmentId: {required: true, message: '请选择科室', trigger: 'change'}
				}
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				name: '',
				pageNumber: 1,
				pageSize: 10
			},
			form: {
				name: '',
				icds: undefined,
			},
			icd: {
				loading: false,
				value: undefined,
				source: undefined,
				list: undefined,
			},
		}
	},
	created() {
		this.loadList();

		// IDC数据
		// api.getIdcList({pageSize: 9999}).then((res)=>{
		// 	if (res.code == 1000 && res.data) {
		// 		// this.listIdc.data = res.data.map(item=> ({ label: item.icdName, key: item.icdCode }));
		// 		// this.listIdc.data = [
		// 		// 	{ label: '11', value: 1}
		// 		// ]
		// 	}
		// });
	},
	methods: {
		async loadList() {
			this.isLoading = true;
			let res = await api.getTagList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item)=>{
					item.date = dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss');
				})
				this.list.data = res.data;
			}
			this.isLoading = false;
		},
		async onLoadIcd(query) {
			if (query != '') {
				this.icd.loading = true;
				api.getIdcList({pageSize: 30, param: query}).then((res)=>{
					this.icd.loading = false;
					if (res.code == 1000 && res.data) {
						// this.icd.list = res.data.map(item=> ({ label: item.icdName, value: item.icdId }));
						this.icd.source = res.data;
					}
				});
			}
		},
		onAddIcd() {
			if (this.icd.value) {
				if (!this.icd.list) {
					this.icd.list = [];
				}
				if (!this.icd.list.find(item => { return item.icdId === this.icd.value})) {
					this.icd.list.push(this.icd.source.find(item => { return item.icdId === this.icd.value}));
				}
			}
		},
		onRemoveIcd(item) {
			this.icd.list.splice(this.icd.list.findIndex(n => { return n.icdId === item.icdId}), 1);
		},
		showDlg(item) {
			this.dlg.active = true;
			this.icd.value = undefined;
			this.icd.source = undefined;
			if (item && item.id > 0) {
				this.$nextTick(()=>{
					this.$nextTick(async ()=>{
						let res = await api.getTag(item.id);
						if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
						this.form = res.data;
						this.icd.list = this.form.icds;
						this.$refs['form'].resetFields();
					});
				});
			} else {
				this.form.id = 0;
				this.form.icds = [];
				this.icd.list = undefined;
				this.$nextTick(()=>{
					this.$refs['form'].resetFields();
				});
			}
		},
		closeDlg() {
			this.dlg.active = false;
		},
		async saveForm() {
			let res;
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					let postForm = { id: this.form.id, name: this.form.name };
					postForm.icds = this.icd.list.map(item=> item.icdCode);
					if (this.form.id > 0) {
						res = await api.editTag(postForm);
					} else {
						// 后端问题，不能带这参数
						this.form.id = null;
						res = await api.addTag(postForm);
					}
					if (res.code != 1000) {
						this.$message.error(res.message);
						return;
					}
					this.loadList();
					this.$message({message: '保存成功',type: 'success'});
					this.closeDlg();
				}
			})
		},
		async delItem(item) {
			let res;
			if (this.isLoading) { return;}
			
			this.isLoading = true;
			if (item && item.id > 0) {
				res = await api.delScheduleTemplate({ids: item.id});
			} else {
				// 批量删除
				if (this.multipleSelection.length == 0) {
					this.isLoading = false;
					return this.$message.warning('未选择任何数据');
				}
				res = await api.delScheduleTemplate({ids: this.multipleSelection.join(',')});
			}
			if (res.code != 1000) {
				this.isLoading = false;
				return this.$message.error(res.message);
			}
			this.isLoading = false;
			this.$message({message: '已删除',type: 'success'});
			this.loadList();
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			this.filter.pageNumber = 1;
			this.loadList();
		},			
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
</style>
